import { HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { get } from 'lodash';
import { pathToRegexp } from 'path-to-regexp';
import { tap } from 'rxjs/operators';

import { formEditIgnorePaths } from './notification-ignore-paths';

@Injectable()
export class SuccessNotificationsInterceptor implements HttpInterceptor {
  private canOpen = true;

  private readonly bufferTime = 500;
  private readonly ignorePaths = [...formEditIgnorePaths, '/graphql', '/search/(.*)', '/codeservice/(.*)'];
  private readonly messages: any = {
    delete: {
      default: 'Resource deleted successfully.',
    },
    patch: {
      default: 'Resource updated successfully.',
    },
    post: {
      default: 'Resource created successfully.',
    },
    put: {
      default: 'Resource updated successfully.',
    },
  };

  constructor(private readonly snackBar: MatSnackBar) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const pathname = new URL(request.url).pathname;

    return next.handle(request).pipe(tap((response) => this.handleEvent(request, response, pathname)));
  }

  ignore(pathname: string) {
    return this.ignorePaths.some((path) => {
      return pathToRegexp(path, undefined, { end: true }).exec(pathname);
    });
  }

  private handleEvent(request: HttpRequest<any>, response: any, pathname: string) {
    if (response instanceof HttpResponse) {
      const method = request.method.toLowerCase();

      const { status } = response;
      const message = get(this.messages, `${method}.${status}`, get(this.messages, `${method}.default`));

      if (message && this.canOpen && !this.ignore(pathname)) {
        this.canOpen = false;
        this.snackBar.open(message);

        setTimeout(() => {
          this.canOpen = true;
        }, this.bufferTime);
      }
    }
  }
}
